const SliderData = [
    {
        slider_id: 1,
        slider_img: './images/slider/slider01.jpg',
        slider_link: '/template/E30/intro', //如果需要連到faq: faq/campaign-preview-link/feature-preview-online
        slider_template_element: 'E30',
        slider_template_title: '端午射龙门',
        slider_template_category_name: '节庆模版',
        //如果需要連到faq, 則要在這邊填寫參數，參數對應 大分類的category_id
        category_id: 0
    },
    {
        slider_id: 2,
        slider_img: './images/slider/slider02.jpg',
        slider_link: '/template/E17/intro',
        slider_template_element: 'E17',
        slider_template_title: '端午情至',
        slider_template_category_name: '节庆模版',
        //for faq link
        category_id: 0
    },
    {
        slider_id: 3,
        slider_img: './images/slider/slider03.jpg',
        slider_link: '/template/E26/intro',
        slider_template_element: 'E26',
        slider_template_title: '电子玛莉',
        slider_template_category_name: '电子模版',
        //for faq link
        category_id: 0
    }
];

export default SliderData;
